@if (isPanelClosed$ | async) {
  <app-new-button
    [class.btn-without-title]="isOneOfPanelsOpen"
    [type]="'primary'"
    [svgIconPath]="'advanced-filter'"
    [size]="'responsive'"
    [ngbTooltip]="isOneOfPanelsOpen ? tooltip : null"
    [tooltipClass]="'default-tooltip media-query-xl-tooltip'"
    [placement]="'bottom'"
    (click)="open()"
  >
    {{ 'core.filters.button' | translate }}
  </app-new-button>
}

<ng-template #tooltip>
  <p>{{ 'core.filters.button' | translate }}</p>
</ng-template>
